import { Component } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { StsSelectors } from "src/app/@store/selectors/sts.selectors";

@Component({
    selector: "app-privacy-policy-frame",
    templateUrl: "./privacy-policy-frame.component.html",
    styleUrls: ["./privacy-policy-frame.component.scss"],
    standalone: false
})
export class PrivacyPolicyFrameComponent {
  pdfIsLoading: boolean = true;
  /** accounts version. used for cache busting */
  version$ = this.store.select(StsSelectors.getVersion);

  public readonly isUkDfpInstance$ = this.store.pipe(select(StsSelectors.isUkDfpInstance));
  public readonly isUkShfyInstance$ = this.store.pipe(select(StsSelectors.isUkShfyInstance));

  constructor(private readonly store: Store) {}

  onProgress(evt: { loaded: number; total: number }) {
    const { loaded, total } = evt;
    if (loaded != total) {
      this.pdfIsLoading = true;
    } else {
      this.pdfIsLoading = false;
    }
  }

  pageRendered(evt) {
    this.pdfIsLoading = false;
    console.log(evt, this.pdfIsLoading);
  }
}
